import clsx from 'clsx';
import { TabItem } from '../types';

interface Props<T extends string> {
  items: TabItem<T>[];
  activeTabId: T;
  onChange: (tabId: T) => void;
}

export function PillTabs<T extends string>(props: Props<T>) {
  const { items, activeTabId, onChange } = props;

  const onClickItem = (item: TabItem<T>) => {
    onChange(item.id);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => (
        <button
          key={item.id}
          className={clsx(
            'rounded-lg px-4 py-2 text-sm font-medium transition-colors',
            'focus-visible:ring-primary-500 dark:focus-visible:ring-offset-ondark-bg-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
            item.id === activeTabId
              ? 'bg-primary-500 text-white'
              : 'border-onlight-text-3 dark:border-ondark-line-2 text-onlight-text-1 dark:text-ondark-text-1 hover:bg-onlight-bg-2 dark:hover:bg-ondark-bg-2 border'
          )}
          aria-current={item.id === activeTabId ? 'page' : undefined}
          onClick={() => onClickItem(item)}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
}

export default PillTabs;
